module.exports = __webpack_public_path__ + "static/media/avatar.f1d71f77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/faces/avatar.jpg
// module id = 240
// module chunks = 0